export default "__VITE_ASSET__BIxLtQ_s__"